<script setup lang="ts">
import BrandLogo from '@mutiblelite/ui/BrandLogo.vue'

const tasks = [
  { name: '视频号', detail: '处理中', tone: 'blue' },
  { name: '抖音', detail: '输出校验通过', tone: 'green' },
]
</script>

<template>
  <div class="product-mockup" aria-label="发多多客户端界面示意">
    <div class="product-mockup__top">
      <BrandLogo class="product-mockup__brand" inverse />
      <span>本地处理</span>
    </div>
    <div class="product-mockup__body">
      <aside>
        <strong>项目</strong>
        <span>任务</span>
        <span>授权</span>
        <span>设置</span>
      </aside>
      <section>
        <div class="product-mockup__video">
          <div />
          <span />
        </div>
        <div class="product-mockup__tasks">
          <div v-for="task in tasks" :key="task.name" :class="`task task--${task.tone}`">
            <i />
            <strong>{{ task.name }}</strong>
            <small v-if="task.name === '抖音'">{{ task.detail }}</small>
            <b>{{ task.name === '抖音' ? '完成' : task.detail }}</b>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<style scoped>
.product-mockup {
  width: min(100%, 530px);
  padding: 30px;
  border-radius: 26px;
  background: #151e2f;
  color: #fff;
  box-shadow: 0 30px 60px rgba(20, 32, 51, 0.25);
}

.product-mockup__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-radius: 12px;
  background: #202b40;
}

.product-mockup__top span {
  padding: 7px 34px;
  border-radius: 99px;
  background: #e8f7f4;
  color: var(--ml-teal);
  font-size: 12px;
  font-weight: 700;
}

.product-mockup__brand {
  gap: 8px;
  font-size: 14px;
}

.product-mockup__brand :deep(.brand-logo__mark) {
  width: 26px;
  height: 26px;
  border-radius: 8px;
  box-shadow: none;
}

.product-mockup__body {
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 20px;
  margin-top: 22px;
}

.product-mockup aside {
  display: grid;
  align-content: start;
  gap: 30px;
  padding: 22px 16px;
  border-radius: 14px;
  background: #0e1626;
  color: #9fb0ca;
  font-size: 13px;
}

.product-mockup aside strong {
  padding: 12px;
  border-radius: 10px;
  background: #202b40;
  color: #fff;
}

.product-mockup section {
  min-width: 0;
}

.product-mockup__video,
.product-mockup__tasks {
  padding: 16px;
  border-radius: 14px;
  background: #fff;
}

.product-mockup__video div {
  height: 102px;
  border-radius: 8px;
  background: #0e1626;
}

.product-mockup__video span {
  display: block;
  width: 64%;
  height: 8px;
  margin-top: 14px;
  border-radius: 99px;
  background: linear-gradient(90deg, var(--ml-brand) 66%, #e4e7ec 66%);
}

.product-mockup__tasks {
  display: grid;
  gap: 10px;
  margin-top: 18px;
}

.task {
  display: grid;
  grid-template-columns: 22px 1fr auto;
  align-items: center;
  gap: 8px;
  padding: 14px;
  border-radius: 10px;
  color: var(--ml-text-primary);
  font-size: 12px;
}

.task i {
  width: 18px;
  height: 18px;
  border-radius: 99px;
}

.task small {
  grid-column: 2 / 3;
  color: var(--ml-text-secondary);
}

.task b {
  grid-column: 3;
  grid-row: 1 / span 2;
}

.task--blue {
  background: #edf5ff;
  color: #2f80ed;
}

.task--blue i {
  background: #2f80ed;
}

.task--green {
  background: var(--ml-success-soft);
}

.task--green i {
  background: var(--ml-success);
}

.task--green b {
  color: var(--ml-success);
}

@media (max-width: 560px) {
  .product-mockup {
    padding: 18px;
  }

  .product-mockup__body {
    grid-template-columns: 1fr;
  }

  .product-mockup aside {
    display: none;
  }
}
</style>
